// eslint-disable-next-line no-restricted-imports
import {Tab, TabProps} from '@headlessui/react';
import {getTrackedOnClickEvent} from '@/components/tracked-atoms/get-tracked-onclick-event';
import {TrackingProps} from '@/components/tracked-atoms/types';
import {TrackingClickPrefix} from '@/services/analytics/analytics-types';

type Props = TabProps & TrackingProps;

export const TrackedTab = ({
  trackingKey,
  trackingAs = TrackingClickPrefix.TAB,
  trackingText,
  onClick,
  ...props
}: Props) => {
  const handleClick = getTrackedOnClickEvent<HTMLButtonElement>(trackingKey, onClick, (event, trackingKey) => ({
    click_as: trackingAs,
    click_action: trackingKey,
    click_text: trackingText ?? (event.currentTarget.textContent?.trim() || ''),
    click_url: null,
  }));

  return <Tab {...props} onClick={handleClick} />;
};
